var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('loading',{attrs:{"active":_vm.showLoading,"can-cancel":false,"loader":"dots","color":_vm.$vuetify.theme.currentTheme.primary,"background-color":"#fff","is-full-page":true},on:{"update:active":function($event){_vm.showLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }